<template>
  <div class="haizol-page-broadcast">
    <i class="iconfont icon-icon-new"></i>
    <span class="broadcast-msg">{{ msg }}</span>
    <i class="el-icon-close broadcast-close" @click="$emit('close')"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '汇集海智客户资源，开启客户高效管理之旅',
    }
  },
}
</script>

<style lang="scss" scoped>
.haizol-page-broadcast {
  /* position: sticky; */
  left: 0;
  right: 0;
  top: 0;
  height: 36px;
  flex-shrink: 0;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background: rgba(49, 140, 237, 0.1);
  border-radius: 2px;
  overflow: hidden;
  user-select: none;
  z-index: 2;
  .broadcast-new {
    width: 42px;
    height: 16px;
    background: #318CED;
    border-radius: 2px;
    margin-right: 12px;
  }
  .broadcast-msg {
    height: 18px;
    line-height: 19px;
    font-family: SourceHanSansSC;
    font-size: 12px;
    color: #318CED;
    letter-spacing: 0;
  }
  .broadcast-close {
    margin-left: auto;
    cursor: pointer;
  }
  .icon-icon-new {
    font-size: 36px;
    color: #318CED;
    margin-right: 12px;
  }
}

</style>